<div class="grid -mx-4 bg-black-alpha-90" >
	<div class="col-8" >
		<!-- <p-scrollPanel [style]="{width: '100%', height: '800px'}"> -->
			<img src="/assets/newsletter.png" class="max-w-full">
    		<iframe  style="min-height:400px; background: black; display:none;" id="iframe" frameBorder="0" allowtransparency="allowtransparency" src="about:blank" width="100%" height="100%" scrolling="no" ></iframe>
		<!-- </p-scrollPanel> -->
			
	</div>
	<div class="col-4 border">
		<h2><i class="pi pi-clock"></i> Toutes les newsletters</h2>
		<div *ngFor="let n of news" (click)="select(n)" class="cursor-pointer">
			Newsletter du {{n.date | date : 'dd MMM YYYY'}}
		</div>
	</div>

</div>